// eslint-disable-next-line import/no-extraneous-dependencies
import { createAction } from 'redux-actions';

export const getAllCategoriesRequest = createAction('GET_ALL_CATEGORIES_REQUEST');
export const getAllCategoriesSuccess = createAction('GET_ALL_CATEGORIES_SUCCESS');
export const getAllCategoriesFailure = createAction('GET_ALL_CATEGORIES_FAILURE');

export const createCategoryRequest = createAction('CREATE_CATEGORY_REQUEST');
export const createCategorySuccess = createAction('CREATE_CATEGORY_SUCCESS');
export const createCategoryFailure = createAction('CREATE_CATEGORY_FAILURE');
export const resetCreateCategoryState = createAction('RESET_CREATE_CATEGORY_STATE');

export const updateCategoryRequest = createAction('UPDATE_CATEGORY_REQUEST');
export const updateCategorySuccess = createAction('UPDATE_CATEGORY_SUCCESS');
export const updateCategoryFailure = createAction('UPDATE_CATEGORY_FAILURE');
export const resetUpdateCategoryState = createAction('RESET_UPDATE_CATEGORY_STATE');

export const deleteCategoryRequest = createAction('DELETE_CATEGORY_REQUEST');
export const deleteCategorySuccess = createAction('DELETE_CATEGORY_SUCCESS');
export const deleteCategoryFailure = createAction('DELETE_CATEGORY_FAILURE');
export const resetDeleteCategoryState = createAction('RESET_DELETE_CATEGORY_STATE');

export const resetCategoryState = createAction('RESET_CATEGORY_STATE');
